export default "__VITE_ASSET__MrmA6$oI__"